module.exports = __webpack_public_path__ + "img/file.273ca931.svg";